<template>
    <div class="translate_page">
        <div class="page-header">
            <el-page-header @back="goBack" :content="typetext"></el-page-header>
        </div>
        <!-- 翻译题 -->
        <div class="content">
      
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span style="font-weight: 700;">{{ specialty.title }}</span>
                    
                    <!-- <el-button v-if="userInfo && userInfo.type == 1" @click="addWork" size="mini" type="primary">布置作业</el-button> -->
                    <el-button :type="button_type" :loading="button_loading" @click="Coll" icon="el-icon-star-off" size="mini" circle></el-button>
                </div>
                <div class="question_box">
                    <div class="question_left" v-if="isNotEmptyObject(specialty)">
                        <el-tabs v-model="specialtyname">
                            <el-tab-pane :label="typetext" name="first">

                                <div v-if="specialty.detail" class="directions"><span class="directions_title">Directions</span>: <div style="margin-top: 15px;text-indent: 30px;" v-html="specialty.detail"></div></div>

                                <div style="text-align: left;font-size: 14px;margin-top: 20px;" v-html="specialty.body"></div>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                    <div v-if="loading" class="question_right">
                        <el-tabs v-model="testname">
                            <el-tab-pane label="试题作答" name="first">
                                <div class="writing">
                                    <el-input type="textarea" v-model="body" placeholder="请在此处作答"></el-input>
                                    
                                    <el-button class="submit" v-if="!form_data.student_id" type="primary" @click="submit" size="small">确认提交</el-button>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="答案解析" name="second">
                                <div class="first_question">
                                    <el-empty v-if="!body.length || !specialty.analysis" description="未完成题目或暂无解析"></el-empty>
                                    <el-col v-if="body.length" :span="22">
                                        <div class="first_question_content">
                                            <div v-if="specialty.analysis">
                                                <h3>解析:</h3>
                                                <div v-html="specialty.analysis"></div>
                                            </div>
                                            <div v-if="specialty.answer">
                                                <h3 style="margin-bottom:20px">范文:</h3>
                                                <div v-html="specialty.answer"></div>
                                            </div>
                                        </div>
                                        
                                  
                                    </el-col>
                                </div>
                                
                            </el-tab-pane>
        
                        </el-tabs>
                    </div>
                </div>
            </el-card>
        </div>
        <Arrangement :dialogVisible="dialogVisible" @update:dialogVisible="updatedialogVisible" :wid="specialty.id" table="specialty_type"></Arrangement>

        <el-dialog
            title="作文批改"
            :visible.sync="dialogVisibleWrite"
            width="700px"
            top="10vh"
            custom-class="write-dialog"
            >
            <div class="write_result">
                <!-- AI说明提示条 -->
                <div class="wr_notice">
                    <i class="el-icon-warning-outline"></i>
                    <span>AI评分仅供参考，具体批改结果以教师评阅为准</span>
                </div>

                <!-- 总体评分 -->
                <div class="wr_section" v-if="correctionData['评分']">
                    <div class="wr_section_title"><i class="el-icon-medal"></i>总体评分</div>
                    <div class="wr_score_box">
                        <div class="wr_score_badge">{{ correctionData['评分']['分数'] }}</div>
                        <div class="wr_score_info">
                            <span class="wr_field_label plain">评分理由</span>
                            <p class="wr_score_reason">{{ correctionData['评分']['评分理由'] }}</p>
                        </div>
                    </div>
                </div>

                <!-- 错误分析 -->
                <div class="wr_section" v-if="errorGroups.length">
                    <div class="wr_section_title"><i class="el-icon-warning-outline"></i>错误分析</div>
                    <div class="wr_group" v-for="group in errorGroups" :key="group.key">
                        <div class="wr_sub_title">{{ group.key }}（{{ group.items.length }}）</div>
                        <div class="wr_card" v-for="(item, i) in group.items" :key="i">
                            <div class="wr_field">
                                <span class="wr_field_label wrong">原文</span>
                                <div class="wr_field_body"><span class="wr_text_wrong">{{ item['错误文本'] }}</span></div>
                            </div>
                            <div class="wr_field">
                                <span class="wr_field_label right">修改为</span>
                                <div class="wr_field_body"><span class="wr_text_right">{{ item['正确形式'] || item['建议用词'] }}</span></div>
                            </div>
                            <div class="wr_field" v-if="item['详细分析']">
                                <span class="wr_field_label plain">详细分析</span>
                                <p class="wr_analysis">{{ item['详细分析'] }}</p>
                            </div>
                            <div class="wr_field" v-if="item['语法规则']">
                                <span class="wr_field_label plain">语法规则</span>
                                <div class="wr_rule">{{ item['语法规则'] }}</div>
                            </div>
                            <div class="wr_field" v-if="item['正例'] && item['正例'].length">
                                <span class="wr_field_label good">正例</span>
                                <div class="wr_example_list">
                                    <div v-for="(ex, j) in item['正例']" :key="'g' + j">{{ ex }}</div>
                                </div>
                            </div>
                            <div class="wr_field" v-if="item['反例'] && item['反例'].length">
                                <span class="wr_field_label bad">反例</span>
                                <div class="wr_example_list">
                                    <div v-for="(ex, j) in item['反例']" :key="'b' + j">{{ ex }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 亮点分析 -->
                <div class="wr_section" v-if="highlightGroups.length">
                    <div class="wr_section_title"><i class="el-icon-star-off"></i>亮点分析</div>
                    <div class="wr_group" v-for="group in highlightGroups" :key="group.key">
                        <div class="wr_sub_title">{{ group.key }}（{{ group.items.length }}）</div>
                        <div class="wr_card" v-for="(item, i) in group.items" :key="i">
                            <div class="wr_field">
                                <span class="wr_field_label hl">{{ group.wordKey }}</span>
                                <div class="wr_field_body"><span class="wr_hl_word">{{ item[group.wordKey] }}</span></div>
                            </div>
                            <div class="wr_field" v-if="item['优秀之处']">
                                <span class="wr_field_label plain">优秀之处</span>
                                <p class="wr_hl_desc">{{ item['优秀之处'] }}</p>
                            </div>
                            <div class="wr_field" v-if="item[group.usageKey] && item[group.usageKey].length">
                                <span class="wr_field_label hl">{{ group.usageKey }}</span>
                                <div class="wr_tags">
                                    <span class="wr_tag" v-for="(u, j) in item[group.usageKey]" :key="j">{{ u }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 写作建议 -->
                <div class="wr_section" v-if="adviceItems.length || tipsList.length">
                    <div class="wr_section_title"><i class="el-icon-edit-outline"></i>写作建议</div>
                    <div class="wr_advice_item" v-for="adv in adviceItems" :key="adv.label">
                        <span class="wr_advice_label">{{ adv.label }}</span>
                        <p>{{ adv.text }}</p>
                    </div>
                    <div class="wr_advice_item" v-if="tipsList.length">
                        <span class="wr_advice_label">实用技巧</span>
                        <div class="wr_tip_item" v-for="(t, i) in tipsList" :key="i">
                            <span class="wr_tip_num">{{ i + 1 }}</span>
                            <span>{{ t.replace(/^技巧\d+[:：]\s*/, '') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Http from "../../src/apis/specialty";
import arrangement from "../../untils/arrangement.vue";
export default {
    components:{
        'Arrangement':arrangement
    },
    props: {  
        form_data: {  
            type: Object,
        },
        userInfo:{
            type: Object,
        }
    },
    data(){
        return{
            dialogVisibleWrite:true,
            button_loading:false,
            button_type:'info',
            specialtyname:'first',
            testname:'first',
            id:'',
            specialty:{},
            specialtytest:[],
            score:0,
            submitanswers:[],
            task_id:0,
            plan_id:0,
            periods:'',
            in_time:'',
            score:0,
            decipher:{
                "评分": {
                    "分数": "9/10",
                    "评分理由": "该作文完整回应了Directions中的所有要求：以学生身份参与在线课程调查，讨论了在线课程的优势（灵活性、资源丰富、费用低廉）、劣势（缺乏面对面互动、缺乏监督、技术问题）并提出了个人建议（线上线下结合、混合模式、设定目标）。字数约160词，符合120-180词的要求。切题性方面，文章标题、开头、主体和结尾均紧扣主题，任务完成度高。语法方面，全文语法基本正确，仅有个别小问题（如冠词使用），不影响理解。词汇方面，使用了abundant、affordable、supervision、hinder、blended model等较高级词汇，表达准确。内容与连贯性方面，结构清晰（引入-优势-劣势-建议-总结），逻辑连贯，过渡自然。扣1分原因：个别表达可更精炼，建议部分可更具体，但整体质量优秀。"
                },
                "错误分析": {
                    "拼写错误": [],
                    "语法错误": [
                        {
                            "错误文本": "allowing students to learn at any time and from any place",
                            "错误位置": [278, 335],
                            "详细分析": "该短语本身语法正确，但'from any place'在正式书面语中稍显口语化，建议改为'from anywhere'更简洁。不过这不构成严格语法错误，属于风格问题。",
                            "正确形式": "allowing students to learn at any time and from anywhere",
                            "语法规则": "介词短语作状语时，'from any place'语法正确，但'from anywhere'更常用且简洁。",
                            "正例": ["She can work from anywhere.", "You can access the file from any device."],
                            "反例": ["She can work from any places.", "You can access the file from any devices."]
                        }
                    ],
                    "用词不当": [
                        {
                            "错误文本": "launched an online survey",
                            "错误位置": [58, 83],
                            "详细分析": "'launched'通常用于产品、项目或活动的启动，用于'survey'虽可接受，但更常见的搭配是'conducted a survey'或'carried out a survey'。'launched'暗示一个较大的启动动作，对于survey略显夸张。",
                            "建议用词": "conducted",
                            "正例": ["The university conducted a survey on student satisfaction.", "They carried out a survey about online learning."],
                            "反例": ["The university launched a survey on student satisfaction.", "They launched a survey about online learning."]
                        },
                        {
                            "错误文本": "hinder learning",
                            "错误位置": [847, 862],
                            "详细分析": "'hinder'意为阻碍、妨碍，通常用于抽象或持续性的障碍。技术问题如网络连接差，用'hinder'可以，但更自然的表达是'impede learning'或'interfere with learning'。'hinder'偏正式，此处语境合适，但可更精准。",
                            "建议用词": "interfere with",
                            "正例": ["Technical problems can interfere with learning.", "Poor connection can impede learning."],
                            "反例": ["Technical problems can hinder learning.", "Poor connection can hinder learning."]
                        }
                    ]
                },
                "亮点分析": {
                    "高级词汇": [
                        {
                            "词汇": "abundant",
                            "位置": [280, 288],
                            "优秀之处": "'abundant'比'plenty of'或'many'更正式、更高级，准确表达资源丰富，适合学术写作。",
                            "其他用法": ["abundant evidence", "abundant opportunities", "abundant natural resources"]
                        },
                        {
                            "词汇": "affordable",
                            "位置": [350, 360],
                            "优秀之处": "'affordable'比'cheap'更得体，强调可负担性而非廉价，语气更积极。",
                            "其他用法": ["affordable housing", "affordable healthcare", "affordable education"]
                        },
                        {
                            "词汇": "supervision",
                            "位置": [430, 440],
                            "优秀之处": "'supervision'比'watching'或'control'更专业，准确描述教师监督。",
                            "其他用法": ["under supervision", "close supervision", "parental supervision"]
                        },
                        {
                            "词汇": "blended model",
                            "位置": [600, 613],
                            "优秀之处": "'blended model'是教育领域的专业术语，显示作者对混合学习的了解，提升文章专业性。",
                            "其他用法": ["blended learning", "blended approach", "blended classroom"]
                        }
                    ],
                    "亮点表达": [
                        {
                            "表达": "Only in this way can online courses truly benefit us.",
                            "位置": [700, 750],
                            "优秀之处": "倒装句强调唯一条件，语气强烈，总结有力，提升文章说服力和文采。",
                            "类似表达": ["Only by doing so can we achieve success.", "Only then did he realize the truth.", "Only in this way can we solve the problem."]
                        },
                        {
                            "表达": "allowing students to learn at any time and from any place",
                            "位置": [180, 240],
                            "优秀之处": "现在分词短语作状语，简洁地补充说明灵活性，结构紧凑，表达流畅。",
                            "类似表达": ["enabling learners to study at their own pace", "permitting users to access materials anytime", "giving students the freedom to choose"]
                        }
                    ]
                },
                "写作建议": {
                    "结构建议": "文章结构已经非常清晰，采用经典的'引入-优势-劣势-建议-总结'五段式，逻辑连贯。建议在建议部分增加一个具体的实施步骤，例如'For instance, schools could upload lecture videos online and use classroom time for group projects and Q&A sessions.'这样能让建议更具操作性。另外，开头段可以更直接地回应题目中的'student union'角色，例如'As a student representative, I would like to...'以增强角色感。",
                    "表达建议": "语言表达总体优秀，但可以进一步丰富句式多样性。例如，在列举优势时，可以交替使用'First... Second... Moreover...'和'Not only... but also...'等结构。此外，注意避免重复使用'online courses'，可以用'e-learning'、'digital courses'、'virtual classes'等替换。个别用词如'launched'可改为'conducted'，'hinder'可改为'interfere with'，使表达更地道。",
                    "内容建议": "内容覆盖了题目要求的所有要点，但可以更深入。例如，在劣势部分，可以补充'缺乏实践环节'或'评估方式单一'等。在建议部分，可以提到'学生应主动参与在线讨论区'或'教师应提供及时反馈'。此外，可以引用具体数据或研究来支持观点，如'According to a recent study, 60% of students struggle with self-discipline in online courses.'这样能增强说服力。",
                    "实用技巧": [
                        "技巧1：使用'PEEL'结构组织段落——Point（观点）、Evidence（证据）、Explanation（解释）、Link（链接）。例如：Online courses are flexible. (Point) A survey shows 80% of students study at night. (Evidence) This means learners can fit study around work. (Explanation) Therefore, flexibility is a key advantage. (Link)",
                        "技巧2：练习'句式转换'——将简单句合并为复合句或使用非谓语动词。例如：原句：Online courses are flexible. They allow students to learn anytime. 改写：Online courses are flexible, allowing students to learn anytime.",
                        "技巧3：建立'同义词替换表'——针对常见词如'advantage'（benefit, merit, strength）、'disadvantage'（drawback, shortcoming, weakness）、'suggest'（recommend, propose, advise），在写作时交替使用，提升词汇多样性。"
                    ]
                }
            },
            typetext:'',
            body:'',
            loading:false,
            dialogVisible:false
        }
    },
    computed: {
        isNotEmptyObject() {
            // 返回一个函数，用于在模板中作为方法调用
            return function(obj) {
                return Object.keys(obj).length > 0;
            };
        },
        // 作文批改数据（decipher 包含批改结构时返回）
        correctionData() {
            const d = this.decipher
            if (!d || typeof d !== 'object' || Array.isArray(d)) return null
            if (d['评分'] || d['错误分析'] || d['亮点分析'] || d['写作建议']) return d
            return null
        },
        // 错误分析分组（自动过滤空分组：拼写错误/语法错误/用词不当）
        errorGroups() {
            const cd = this.correctionData
            if (!cd || !cd['错误分析']) return []
            const ea = cd['错误分析']
            return ['拼写错误', '语法错误', '用词不当']
                .filter(key => Array.isArray(ea[key]) && ea[key].length > 0)
                .map(key => ({ key: key, items: ea[key] }))
        },
        // 亮点分析分组（高级词汇/亮点表达）
        highlightGroups() {
            const cd = this.correctionData
            if (!cd || !cd['亮点分析']) return []
            const hl = cd['亮点分析']
            return [
                { key: '高级词汇', wordKey: '词汇', usageKey: '其他用法' },
                { key: '亮点表达', wordKey: '表达', usageKey: '类似表达' }
            ]
                .filter(g => Array.isArray(hl[g.key]) && hl[g.key].length > 0)
                .map(g => ({ key: g.key, wordKey: g.wordKey, usageKey: g.usageKey, items: hl[g.key] }))
        },
        // 写作建议条目（结构/表达/内容）
        adviceItems() {
            const cd = this.correctionData
            if (!cd || !cd['写作建议']) return []
            const adv = cd['写作建议']
            return [
                { key: '结构建议', label: '结构建议' },
                { key: '表达建议', label: '表达建议' },
                { key: '内容建议', label: '内容建议' }
            ].filter(i => adv[i.key]).map(i => ({ label: i.label, text: adv[i.key] }))
        },
        // 实用技巧列表
        tipsList() {
            const cd = this.correctionData
            const tips = cd && cd['写作建议'] && cd['写作建议']['实用技巧']
            return Array.isArray(tips) ? tips : []
        }
    },
    mounted(){
        window.addEventListener('popstate', this.handlePopState);  
    },
    // activated(){
    //     this.id = this.$route.query.id
    //     this.task_id = this.$route.query.task_id
    //     this.plan_id = this.$route.query.plan_id
    //     this.periods = this.$route.query.periods
    //     this.getData()
    // },
    methods:{
        addWork(){
            this.dialogVisible = true
        },
        updatedialogVisible(e){
            this.dialogVisible = e
        },
        handlePopState(){
            this.specialty = {}
            this.specialtytest = []
            this.loading = false
        },
        getData(){
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.4)'
            });
            var params = {}
            params.id = this.form_data.id
            if(this.form_data.student_id){
                params.student_id = this.form_data.student_id
            }
            Http.Detail(params).then((res) => {
                this.specialty = res.data.specialty
                this.specialtytest = res.data.specialty_test
                this.body = res.data.submitanswers?res.data.submitanswers:""
                this.button_type = res.data.collection?'primary':'info'
                this.in_time = res.data.time
                // 接口的 decipher 只有确实是批改结构时才覆盖，避免把模拟数据/已有数据冲成空
                var apiDec = res.data.decipher
                console.log('[translate] 接口返回 decipher:', apiDec, '类型:', Object.prototype.toString.call(apiDec))
                var isCorrection = function(d){
                    if (!d || typeof d !== 'object' || Array.isArray(d)) return false
                    return !!(d['评分'] || d['错误分析'] || d['亮点分析'] || d['写作建议'])
                }
                if (isCorrection(apiDec)) {
                    this.decipher = apiDec
                } else if (Array.isArray(apiDec) && apiDec.length && isCorrection(apiDec[0])) {
                    this.decipher = apiDec[0]
                }
                // 不是批改结构则保留原 decipher（模拟数据或上一次的有效值）
                this.score = res.data.score * 100
                this.typetext = res.data.typetext
                this.loading = true
                loading.close()
            });

        },
       /**
        *   选择题
        */
        optionsQuestion(id,option){
            var params = JSON.parse(JSON.stringify(this.options))
            params[id] = option.name

            this.options = params
        },
        submit(){
            var params = {}
            params.body = this.body
            params.w_id = this.form_data.id
            params.worktype = this.form_data.worktype
            params.table_type = 'specialty'
            params.in_time = this.in_time
            params.task_id = this.form_data.task_id
            params.plan_id = this.form_data.plan_id
            params.periods = this.form_data.periods
            params.source = 'PC'
            Http.Submit(params).then((res) => {
                if(res.code){
                    this.$alert(res.msg, '提示', {
                        confirmButtonText: '确定'
                    });
                    this.getData()
                }else{
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        // 收藏
        Coll(){
            if(!this.userInfo){
                this.$router.push({name:'Login',query:{redirect:encodeURIComponent(window.location.href)}});
                return false;
            }
            this.button_loading = true
            var params = {}
            params.wid = this.form_data.id
            params.tabel_type = 'specialty'
            params.title = this.specialty.title
            Http.Coll(params).then((res) => {
                this.button_loading = false
                if(this.button_type == 'primary'){
                    this.button_type = 'info'
                }else{
                    this.button_type = 'primary'
                }
     
                this.$message({
                    showClose: true,
                    message: res.msg,
                    type: res.code ? 'success' : 'error'
                });
                
            });
        },
        goBack(){
            window.history.back();
        }
    }
}
</script>
<style scoped>
.content{
    width: 1200px;
    margin: 0 auto;
}
.first_question_content{
    display: flex;
    flex-direction: column;
    gap: 20px;
}
.content >>> .el-card__header{
    display: inline-block;
    width: 100%;
}
.clearfix >>> .el-button{
    float: right;
    margin-left: 15px;
}
.clearfix span{
    float: left;
}
.question_box{

    width: 100%;
    height: 800px;
}
.question_left{
    width: 50%;
    float: left;
    height: 800px;
    overflow-y: auto;
    box-sizing: border-box;
}
.question_left::-webkit-scrollbar {  
  width: 10px; /* 滚动条的宽度 */  
}  
  
.question_left::-webkit-scrollbar-track {  
  background: rgba(0, 0, 0, 0); /* 滚动条轨道的背景色，设置透明度 */  
}  
  
.question_left::-webkit-scrollbar-thumb {  
  background: rgba(0, 0, 0, 0); /* 滚动条滑块的颜色，设置透明度 */  
  border-radius: 10px; /* 圆角效果 */  
}  
  
.question_left::-webkit-scrollbar-thumb:hover {  
  background: rgba(0, 0, 0, 0); /* 滚动条滑块hover时的颜色，设置透明度 */  
}
.question_left >>> .el-tabs__header{
    position: sticky;
    background: #ffffff;
    top: 0;
    z-index: 99;
}
.question_left >>> .el-tabs__content{

    padding: 0 20px;
}
.question_right{
    width: 50%;
    display: inline-block;
    height: 800px;
    overflow-y: auto;
}
.question_right >>> .el-tabs__header{
    position: sticky;
    background: #ffffff;
    top: 0;
    z-index: 99;
}
.question_right::-webkit-scrollbar {  
  width: 10px; /* 滚动条的宽度 */  
}  
  
.question_right::-webkit-scrollbar-track {  
  background: rgba(0, 0, 0, 0); /* 滚动条轨道的背景色，设置透明度 */  
}  
  
.question_right::-webkit-scrollbar-thumb {  
  background: rgba(0, 0, 0, 0); /* 滚动条滑块的颜色，设置透明度 */  
  border-radius: 10px; /* 圆角效果 */  
}  
  
.question_right::-webkit-scrollbar-thumb:hover {  
  background: rgba(0, 0, 0, 0); /* 滚动条滑块hover时的颜色，设置透明度 */  
}
.first_question {
    padding: 20px;
    width: 95%;
    display: inline-block;
    text-align: left;
    margin-bottom: 15px;
}
.first_question >>> .el-textarea__inner{
    min-height: 150px !important;
}
.first_question >>> .el-card__body{
    padding: 10px;
}
.first_question >>> .el-col{
    margin-top: 15px;
    font-size: 14px;
    line-height: 20px;
}
.first_question .question{
    font-size: 16px;
    font-weight: 700;
    color: #000000;
    line-height: 23px;
    display: inline-block;
    width: 100%;
    cursor: pointer;
}
.right{
    background: #e9f7ff !important;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
}
.error{
    background: #ffd7d7 !important;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
}
.specialtytest{
    width: 100% !important;
}
.directions{
    width: 100%;
    text-align: left;
}
.directions_title{

    font-weight: 700;
}
.submit{
    margin-top: 20px;
}
.writing .el-textarea >>> .el-textarea__inner{
    min-height: 600px !important;
}
.translate_page >>> .write-dialog{
    border-radius: 8px;
}
.page-header{
    width: 1200px;
    background: #ffffff;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 20px;
}
.page-header >>> .el-page-header{
    line-height: 40px;
    padding: 5px 15px;
}
.page-header >>> .el-page-header__content{
    font-size: 15px;
}

/* ==================== 作文批改弹窗内容 ==================== */
.write_result{
    font-size: 14px;
    color: #303133;
    line-height: 1.7;
    text-align: left;
}
.wr_notice{
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12.5px;
    color: #909399;
    background: #f4f4f5;
    border: 1px dashed #dcdfe6;
    border-radius: 6px;
    padding: 8px 12px;
    margin-bottom: 22px;
}
.wr_notice i{
    color: #e6a23c;
    font-size: 16px;
}
.wr_section{
    margin-bottom: 26px;
}
.wr_section:last-child{
    margin-bottom: 0;
}
.wr_section_title{
    display: flex;
    align-items: center;
    font-size: 15px;
    font-weight: 700;
    color: #303133;
    padding-left: 10px;
    border-left: 3px solid #409eff;
    margin-bottom: 12px;
}
.wr_section_title i{
    color: #409eff;
    margin-right: 6px;
    font-size: 16px;
}
.wr_group{
    margin-bottom: 16px;
}
.wr_group:last-child{
    margin-bottom: 0;
}
.wr_sub_title{
    font-size: 13px;
    font-weight: 700;
    color: #909399;
    margin-bottom: 8px;
}
.wr_card{
    background: #fafbfc;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 12px 14px;
    margin-bottom: 10px;
}
.wr_card:last-child{
    margin-bottom: 0;
}
/* 字段行：标签独占一行，内容另起一行，避免左右混排 */
.wr_field{
    margin-bottom: 12px;
}
.wr_field:last-child{
    margin-bottom: 0;
}
.wr_field_label{
    display: inline-block;
    font-size: 12px;
    font-weight: 700;
    line-height: 20px;
    padding: 0 10px;
    border-radius: 4px;
    margin-bottom: 6px;
    white-space: nowrap;
}
.wr_field_body{
    line-height: 1.6;
}
.wr_field_label.plain{
    color: #909399;
    background: #F4F4C6;
}
.wr_field_label.wrong,
.wr_field_label.bad{
    color: #f56c6c;
    background: #fef0f0;
}
.wr_field_label.right,
.wr_field_label.good{
    color: #67c23a;
    background: #f0f9eb;
}
.wr_field_label.hl{
    color: #e6a23c;
    background: #fdf6ec;
}
.wr_text_wrong{
    display: inline-block;
    color: #f56c6c;
    background: #fef0f0;
    padding: 2px 8px;
    border-radius: 4px;
    text-decoration: line-through;
    font-size: 13px;
    line-height: 20px;
    word-break: break-all;
}
.wr_text_right{
    display: inline-block;
    color: #67c23a;
    background: #f0f9eb;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 600;
    line-height: 20px;
    word-break: break-all;
}
.wr_analysis{
    margin: 0;
    font-size: 13px;
    color: #606266;
    line-height: 1.8;
    text-align: left;
}
.wr_rule{
    font-size: 12px;
    color: #909399;
    background: #f4f4f5;
    padding: 6px 10px;
    border-radius: 4px;
    line-height: 1.6;
}
.wr_example_list{
    font-size: 12px;
    color: #606266;
    line-height: 20px;
}
/* 评分 */
.wr_score_box{
    display: flex;
    align-items: flex-start;
    gap: 16px;
    background: #f0f5ff;
    border: 1px solid #d9ecff;
    border-radius: 8px;
    padding: 16px;
}
.wr_score_info{
    flex: 1;
    min-width: 0;
}
.wr_score_badge{
    flex-shrink: 0;
    width: 76px;
    height: 76px;
    border-radius: 50%;
    background: linear-gradient(135deg, #409eff, #2563eb);
    color: #fff;
    font-size: 20px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.35);
}
.wr_score_reason{
    margin: 0;
    font-size: 13px;
    color: #606266;
    line-height: 1.9;
    text-align: left;
}
/* 亮点 */
.wr_hl_word{
    display: inline-block;
    color: #e6a23c;
    background: #fdf6ec;
    border: 1px solid #faecd8;
    padding: 2px 10px;
    border-radius: 4px;
    font-weight: 700;
    font-size: 13px;
    line-height: 20px;
}
.wr_hl_desc{
    margin: 0;
    font-size: 13px;
    color: #606266;
    line-height: 1.8;
    text-align: left;
}
.wr_tags{
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}
.wr_tag{
    font-size: 12px;
    color: #409eff;
    background: #ecf5ff;
    border: 1px solid #d9ecff;
    border-radius: 4px;
    padding: 1px 8px;
}
/* 写作建议 */
.wr_advice_item{
    margin-bottom: 14px;
}
.wr_advice_item:last-child{
    margin-bottom: 0;
}
.wr_advice_label{
    display: inline-block;
    font-size: 12px;
    font-weight: 700;
    color: #409eff;
    background: #ecf5ff;
    padding: 2px 10px;
    border-radius: 4px;
    margin-bottom: 6px;
}
.wr_advice_item p{
    margin: 0;
    font-size: 13px;
    color: #606266;
    line-height: 1.8;
    text-align: left;
}
.wr_tip_item{
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font-size: 13px;
    color: #606266;
    line-height: 1.8;
    margin-top: 8px;
}
.wr_tip_num{
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #409eff;
    color: #fff;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 3px;
}
</style>

<style>
/* 作文批改弹窗：固定80%高度，内容区滚动（el-dialog内部结构，需非scoped样式） */
.write-dialog{
    height: 80vh;
    display: flex;
    flex-direction: column;
}
.write-dialog .el-dialog__body{
    flex: 1;
    overflow-y: auto;
}
</style>